import StandardGateway from './lib/standard_gateway';

const DEFAULT_TIMEOUT = 10000;

export default class StandardHttpConfigGateway extends StandardGateway {
  constructor(backend, endpoint) {
    super(backend, endpoint);
  }

  get(reqConfig = {}) {
    const url = this.endpoint.fetchUrl;

    return this.http
      .get(url, { timeout: DEFAULT_TIMEOUT, ...reqConfig })
      .then(res => {
        this.observer.onFetchSuccess(res);
        return res;
      })
      .catch(error => {
        this.observer.onFetchError(error);
        throw error;
      });
  }
}
